import { type RootState } from "features/Application/store/store";

export const selectMyData = (state: RootState) => state.account.myData.current;
export const selectMyDataStatus = (state: RootState) => state.account.myData.status;
export const selectMyDataError = (state: RootState) => state.account.myData.errorMessage;
